exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".confirm-button-container{margin:0 0 20px}", "", {"version":3,"sources":["/../../../../../sassjs-loader/index.js!/home/vsts/work/1/s/src/components/lbaConfirmButton/lbaConfirmButton.scss"],"names":[],"mappings":"AAAA,0BACE,eAAiB,CAAE","file":"lbaConfirmButton.scss","sourcesContent":[".confirm-button-container {\n  margin: 0 0 20px; }\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/sassjs-loader!./src/components/lbaConfirmButton/lbaConfirmButton.scss
// module id = 440
// module chunks = 0